import { render, staticRenderFns } from "./KabYahukimo.vue?vue&type=template&id=47ed30c1"
import script from "./KabYahukimo.vue?vue&type=script&lang=js"
export * from "./KabYahukimo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports